import axios from 'axios';
import { MutationTree, ActionTree } from 'vuex';
import Utility from '@/common/UtilityFunctions.js';
import { RootState } from './interfaces/RootState';
import { CreateMemberStoreState } from './interfaces/CreateMemberStoreState';
import viewModel from './createMember/viewmodel.json';

export const state: CreateMemberStoreState = {
  vueModel: viewModel,
  contentLoaded: false,
  stepOnePath: '/',
  stepTwoPath: '/kan-jeg-blive-medlem',
  stepThreePath: '/medlem-resultat',
  hasBrandAffinityMatch: false,
  matchedBrandAffinityId: null,
  matchedBrandAffinityLink: null,
  questionChangeIndex: null,
  affinityMatchedQuestion: null,
  isStudent: false,
  studentInsuranceLink: null,
  noResultAfterAllQuestions: false,
  redirectTransferData: null,
  buttons: {
    prevButton: {
      path: null,
      class: null,
      label: null,
      redirectTo: null
    },
    nextButton: {
      path: null,
      class: null,
      label: null,
      redirectTo: null
    }
  },
  productsInBasket: [],
  currentBrandMatch: false
};

export const mutations: MutationTree<CreateMemberStoreState> = {
  setAffinityId(state, payload) {
    state.matchedBrandAffinityId = payload;
  },
  setAffinityMatchedQuestion(state, payload) {
    state.affinityMatchedQuestion = payload;
  },
  setButtons(state, payload) {
    state.buttons = payload;
  },
  setCprConsent(state, payload) {
    state.vueModel.memberRootDataTemplateModel.cprConsent = payload;
  },
  setCprNumber(state, payload) {
    state.vueModel.memberRootDataTemplateModel.cprNumber = payload;
  },
  setEmail(state, payload) {
    state.vueModel.memberRootDataTemplateModel.email = payload;
  },
  setHasBrandAffinityMatch(state, payload) {
    state.hasBrandAffinityMatch = payload;
  },
  setIsStudent(state, payload) {
    state.isStudent = payload;
  },
  setMatchedBrandAffinityLink(state, payload) {
    state.matchedBrandAffinityLink = payload;
  },
  setMemberGroup(state, payload) {
    state.vueModel.memberRootDataTemplateModel.memberGroup = payload;
  },
  setNoResultAfterAllQuestions(state, payload) {
    state.noResultAfterAllQuestions = payload;
  },
  setPhoneNumber(state, payload) {
    state.vueModel.memberRootDataTemplateModel.phoneNumber = payload;
  },
  setQuestionChangeIndex(state, payload) {
    state.questionChangeIndex = payload;
  },
  setQuestions(state, payload) {
    state.vueModel.stepTwoMemberQuestions.questions = payload;
  },
  setStudentInsuranceLink(state, payload) {
    state.studentInsuranceLink = payload;
  },
  setVueModel(state, payload) {
    state.vueModel = payload;
    state.contentLoaded = true;
  },
  setRedirectTransferData(state, payload) {
    state.redirectTransferData = payload;
  },
  setProductsInBasket(state, payload) {
    state.productsInBasket = payload;
  },
  setCurrentBrandMatch(state, payload) {
    state.currentBrandMatch = payload;
  }
};

export const actions: ActionTree<CreateMemberStoreState, RootState> = {
  async setInitialModel({ commit }, payload) {
    await axios
      .get('/api/eligibility/get/' + payload)
      .then((response) => {
        commit('setVueModel', response.data);
      })
      .catch((err) => {
        Utility.logError(err, this);
      });
  },
  setButtons({ commit }, payload) {
    commit('setButtons', payload);
  },
  async setProductsInBasket({ commit }) {
    await axios
      .get(Utility.constants().API.basket_products)
      .then((response) => {
        commit('setProductsInBasket', response.data);
      })
      .catch((err) => {
        Utility.logError(err, this);
      });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
